<template>
    <div class="row event-info" v-if="event">
        <div class="row"><div class="col-sm-2 text-right"><strong>Event Name</strong></div>&nbsp;<div class="col-sm-4">{{ event.club_event_name }}</div></div>
        <div class="row"><div class="col-sm-2 text-right"><strong>Event Type</strong></div>&nbsp;<div class="col-sm-4">{{ event.event_type }}</div></div>
        <div class="row"><div class="col-sm-2 text-right"><strong>Requires Volunteers</strong></div>&nbsp;<div class="col-sm-4">{{ event.requires_volunteers ? 'Yes' : 'No' }}</div></div>
        <div class="row"><div class="col-sm-2 text-right"><strong>Start Date</strong></div>&nbsp;<div class="col-sm-4">{{ formatDate(event.start_date) }}</div></div>
        <div class="row"><div class="col-sm-2 text-right"><strong>End Date</strong></div>&nbsp;<div class="col-sm-4">{{ formatDate(event.end_date) }}</div></div>
    </div>
</template>
<style scoped>
    .event-info {
        margin-bottom: 1.5em;
    }
</style>
<script>
    export default {
        props: [
            'eventId'
        ],

        data() {
            return {
                event: null
            }
        },

        mounted() {
            this.getEvent();
        },

        methods: {
            getEvent() {
                axios.get(`/api/v1/club_events/${this.eventId}`)
                    .then(response => {
                        this.event = response.data;
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching the event.', type: 'error'});
                    });
            },
            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY")
            }
        }
    }
</script>